import { HOME } from "./parameters.js";
import { VIEW } from "./types.js";

const query = (search, type) => new URLSearchParams(search).get(type);

const GetParam = (search) => {
  const param = query(search, VIEW);
  return param ? param : HOME;
};

export { GetParam };
